import { useEffect, type ReactNode } from 'react';
import type { Action } from 'react-sweet-state';
import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';
import { abortAll } from '@atlaskit/react-ufo/interaction-metrics';
import { fg } from '@confluence/feature-gating';

type State = {
	active: boolean;
};

const initialState = { active: false };

const actions = {
	setActive:
		(active: boolean): Action<State> =>
		({ setState }) => {
			setState({ active });
		},
};

const ModernizeChangeboardingStore = createStore({
	initialState,
	actions,
});

export const useModernizeChangeboardingActive = createStateHook(ModernizeChangeboardingStore, {
	selector: (state) => state.active,
});

const useActions = createActionsHook(ModernizeChangeboardingStore);

export const WithModernizeChangeboardingActive = ({ children }: { children: ReactNode }) => {
	const { setActive } = useActions();
	useEffect(() => {
		if (fg('confluence_frontend_exclude_changeboarding_from_vc'))
			abortAll('new_interaction', 'modernize-changeboarding');
		void setActive(true);
		return () => {
			void setActive(false);
		};
	}, [setActive]);

	return children;
};
